import { type Board } from '@air/api/types';

export type BoardSelectInitialBoard = Pick<Board, 'id'> & {
  ancestors?: Pick<Board, 'id'>[];
};

export const getBoardSelectInitialIndex = (
  boards: Pick<Board, 'id'>[],
  initialBoard: BoardSelectInitialBoard | undefined,
): number | undefined => {
  if (!initialBoard) {
    return undefined;
  }

  const rootBoardId = initialBoard.ancestors?.[0]?.id ?? initialBoard.id;
  const index = boards.findIndex((board) => board.id === rootBoardId);

  return index > -1 ? index : undefined;
};

export const getBoardSelectInitiallyExpandedBoardIds = (
  initialBoard: BoardSelectInitialBoard | undefined,
): Set<Board['id']> => {
  if (!initialBoard) {
    return new Set();
  }

  return new Set([initialBoard.id, ...(initialBoard.ancestors?.map((ancestor) => ancestor.id) ?? [])]);
};
